
import { HistoryRecord } from "../DealHistory/DealHistory";

export const isLargeContent = (record: HistoryRecord): boolean => {
  const threshold = 40;
  return (
    record.field.length > threshold ||
    record.oldValue.length > threshold ||
    record.newValue.length > threshold
  );
};
